<!-- eslint-disable @angular-eslint/template/prefer-control-flow -- Angular atual do projeto ainda não compila @if. -->
<div class="modalbox success col-sm-8 col-md-6 col-lg-5 center animate">
    <div class="icon" [class.icon--warning]="isWarning">
        <mat-icon class="status-icon" aria-hidden="true">{{ isWarning ? 'priority_high' : 'close' }}</mat-icon>
    </div>
    <h1 class="font-semibold line-clamp-3 text-2xl leading-tight my-2" autoTranslate>{{ heading }}</h1>
    <p class="text-2xl font-medium leading-tight" *ngIf="data.title">{{ data.title | autoTranslate }}</p>
    <br />
    <p
        class="text-lg font-normal leading-tight"
        style="overflow: auto !important; max-height: calc(100vh - 18rem)"
        *ngIf="data.message"
        [innerHTML]="data.message | autoTranslate"
    ></p>
</div>
